import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	lastUpdated: {
		id: 'search-page.filters.names.lastUpdated',
		defaultMessage: 'Last updated',
		description: 'Label for filtering by last updated time',
	},
});
